import { Box } from '@terra/ui-styled-system';
import type { ReactNode } from 'react';
import type { TimelineDotTone } from './types';

type TimelineDotProps = {
  icon?: ReactNode;
  tone?: TimelineDotTone;
};

export const TimelineDot = ({ icon, tone = 'default' }: TimelineDotProps) => {
  const isAccent = tone === 'accent';

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width={8}
      height={8}
      borderRadius="full"
      bg={isAccent ? 'bg.severity.high' : 'bg.default'}
      borderWidth="1px"
      borderColor={isAccent ? 'border.severity.high' : 'border.default'}
      color={isAccent ? 'fg.severity.high' : 'fg.muted'}
      flexShrink={0}
      transition="all 0.2s"
    >
      {icon}
    </Box>
  );
};
